<template>
    <form-page
        v-if="isload"
        :page-type="pageInfo.page_type"
        :title="pageTitle"
        :pageInfo="pageInfo"
        :forms="formobj"
        @update:onTabChange="onTabChange"
        @update:onSubmit="onSubmit"
    >
        <template #form_top>
            <slot name="form_top">
            </slot>
        </template>
        <template #content_top>
            <slot name="content_top">
            </slot>
        </template>
        <template #form_bottom>
            <slot name="form_bottom">
            </slot>
        </template>
        <template #content_bottom>
            <slot name="content_bottom">
            </slot>
        </template>
    </form-page>
</template>

<script>
import { getCurrentInstance, defineComponent, ref, provide, readonly, inject, reactive, toRaw } from 'vue'
import FormPage from '@/components/ui-form-page'

export default defineComponent({
    props: {
        title: {
            type: String,
            default: ''
        },
        urls: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        FormPage
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance()
        const dialogFormVisible = ref(false)
        const isload = ref(false)
        const pageTitle = ref(props.title)
        const formobj = ref({})
        const pageInfo = ref()
        const urls = ref(props.urls)
        const postUrl = ref()
        const pagemeta = proxy.$router.currentRoute.value.meta
        const map = ref(proxy.$router.currentRoute.value.query)

        const add = (val, url = '') => {
            return new Promise((resolve, reject) => {
                postUrl.value = url || urls.value.add
                getInfo(val).then(() => {
                    resolve(1)
                })
            })
        }
        const edit = (val, url = '') => {
            return new Promise((resolve, reject) => {
                postUrl.value = url || urls.value.edit
                getInfo(val).then(() => {
                    resolve(1)
                })
            })
        }

        const onSubmit = (obj) => {
            proxy.jiu.request(postUrl.value, obj, 'POST').then((res, rej) => {
                dialogFormVisible.value = false
                let data = res.data
                if (typeof data !== 'undefined' && 'is_step' in data && data.is_step) {
                    add(data.query, data.url)
                    return false
                }
                // context.emit('update:getDataList', res)
                proxy.jiu.toast(res.message)
                context.emit('update:getDataList')
            }).catch((error) => {
                proxy.jiu.showError(error)
            })
        }
        const getInfo = (map) => {
            return new Promise((resolve, reject) => {
                isload.value = false
                proxy.jiu.request(postUrl.value, map).then((res, rej) => {
                    formobj.value = res.data.form_items
                    pageInfo.value = res.data
                    isload.value = true
                    pageTitle.value = res.data.page_title
                    dialogFormVisible.value = true
                    resolve(1)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                    reject(error)
                })
            })
        }

        const onTabChange = (e) => {
            isload.value = false
            getInfo(Object.assign(map.value, { group: e }))
        }

        if (pagemeta.isonlyform) {
            postUrl.value = pagemeta.urls.url
            getInfo(map.value)
        }
        provide('dialogFormVisible', dialogFormVisible)
        return {
            pageInfo,
            formobj,
            isload,
            pageTitle,
            onSubmit,
            onTabChange,
            add,
            edit
        }
    }
})
</script>
<style>

</style>
